var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wscn-http404-container"},[_c('div',{staticClass:"wscn-http404"},[_c('div',{staticClass:"bullshit"},[_c('img',{attrs:{"src":require("../assets/images/bg_task.png")}}),_vm._v(" "),_c('div',{staticClass:"bullshit__info"},[_vm._v(_vm._s(_vm.message))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf795c3a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../vue-common-laboratory/src/layout/NoMessage.vue
// module id = null
// module chunks = 